






















































import {
  computed,
  defineComponent,
  onMounted,
  onBeforeUnmount,
  watch,
  PropType
} from '@vue/composition-api';
import theme from '@zk/theme/lib/variables.scss';
// import { useInstance } from 'common-module/src/util/useInstance';
import { useI18n } from 'common-module/src/util/useI18n';
import { useRequestServe } from './useRequestServe';

import {
  RequestConfig,
  RequestParam,
  RequestFunction
} from './types';

export default defineComponent({
  name: 'NetworkRequest',
  props: {
    request: {
      type: Function as PropType<RequestFunction>,
      default: null
    },
    requestApi: {
      type: String,
      default: ''
    },
    // 是否自动初始化加载
    isAutoLoad: {
      type: Boolean,
      default: false
    },
    // 自动重试次数
    autoRetryCount: {
      type: Number,
      default: 0
    },
    // 重试间隔，单位ms
    retryInterval: {
      type: Number,
      default: 3000
    },
    // 自定义请求配置
    requestConfig: {
      type: Object as PropType<RequestConfig>,
      default: null
    },
    showErrorAlert: {
      type: Boolean,
      default: false
    },
    // api 模式，自定义请求参数
    requestParam: {
      type: Object as PropType<RequestParam>,
      default: null
    },
    loadingText: {
      type: String,
      default: 'loading...'
    },
    loadingClass: {
      type: String,
      default: ''
    },
    errorClass: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    forceLoading: {
      type: Boolean,
      default: false
    },
    forceError: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    // const instance = useInstance();
    const { t } = useI18n();

    const {
      onRefresh,
      onCancel,
      stopRetry,
      state,
      isLoading,
      isRetrying,
      retryCount,
      response
    } = useRequestServe({
      request: props.request,
      requestApi: props.requestApi,
      maxRetryCount: props.autoRetryCount,
      retryInterval: props.retryInterval,
      requestConfig: props.requestConfig,
      requestParam: props.requestParam,
      showErrorAlert: props.showErrorAlert
    });

    const loading = computed(() => props.forceLoading || isLoading.value || isRetrying.value);
    const showError = computed(() => props.forceError || state.value === 'fail' && !loading.value);

    const errorInfoMsg = computed(() => {
      if (state.value !== 'fail') {
        return '';
      }
      const errorString = new String(response.value);
      const errorText = errorString.includes('Network')
        ? t('guide.task.info')
        : props.errorText || t('commonModule.errorRetry');
      return errorText;
    });

    watch(response, (newRes) => {
      ctx.emit('change', {
        state: state.value,
        result: newRes
      });
    });

    onMounted(() => {
      // 初始自动加载
      props.isAutoLoad && onRefresh();
    });
    onBeforeUnmount(() => {
      onCancel();
      stopRetry();
    });

    return {
      errorInfoMsg,
      loading,
      load: onRefresh,
      onCancel,
      showError,
      response,
      retryCount,
      isRetrying
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
